var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7005 14.0625C15.7005 14.373 15.4485 14.625 15.138 14.625H2.763C2.4525 14.625 2.2005 14.373 2.2005 14.0625C2.2005 13.752 2.4525 13.5 2.763 13.5H15.138C15.4485 13.5 15.7005 13.752 15.7005 14.0625ZM15.75 10.6875C15.75 10.377 15.498 10.125 15.1875 10.125H2.763C2.4525 10.125 2.2005 10.377 2.2005 10.6875C2.2005 10.998 2.4525 11.25 2.763 11.25H15.1875C15.498 11.25 15.75 10.998 15.75 10.6875ZM7.3125 7.3125C7.3125 7.002 7.0605 6.75 6.75 6.75H2.763C2.4525 6.75 2.2005 7.002 2.2005 7.3125C2.2005 7.623 2.4525 7.875 2.763 7.875H6.75C7.0605 7.875 7.3125 7.623 7.3125 7.3125ZM7.3125 3.9375C7.3125 3.627 7.0605 3.375 6.75 3.375H2.763C2.4525 3.375 2.2005 3.627 2.2005 3.9375C2.2005 4.248 2.4525 4.5 2.763 4.5H6.75C7.0605 4.5 7.3125 4.248 7.3125 3.9375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.70547C15 5.92638 14.8209 6.10547 14.6 6.10547L12.7332 6.10547C12.5123 6.10547 12.3332 5.92638 12.3332 5.70547L12.3332 3.83872C12.3332 3.61781 12.5123 3.43872 12.7332 3.43872L14.6 3.43872C14.8209 3.43872 15 3.6178 15 3.83872L15 5.70547Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.70547C11.75 5.92638 11.5709 6.10547 11.35 6.10547L9.48325 6.10547C9.26234 6.10547 9.08325 5.92638 9.08325 5.70547L9.08325 3.83872C9.08325 3.61781 9.26234 3.43872 9.48325 3.43872L11.35 3.43872C11.5709 3.43872 11.75 3.6178 11.75 3.83872L11.75 5.70547Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.79999L10 7.39999",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 5.79999L13.3 7.39999",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteList);
export default __webpack_public_path__ + "static/media/quote-list.a899210acec0914db8245ff782050ee6.svg";
export { ForwardRef as ReactComponent };